import { ApolloLink } from '@apollo/client'

import vouchLogger from '@/lib/vouchLogger'

export const responseTimeLink = new ApolloLink((operation, forward) => {
  const startTime = new Date().getTime()

  return forward(operation).map(result => {
    const duration = Math.abs(new Date().getTime() - startTime)

    vouchLogger.info('GraphQL request logging', {
      duration,
      operationName: operation.operationName,
      query: operation.query,
      status: operation.getContext().response.status,
    })

    return result
  })
})
